import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import OverflowTooltip from '@shared/overflow-tooltip';
import FilterCheckbox from '@shared/filter-checkbox';
import '../filter.scss';

const FilterGroupItem = ({
  enabled,
  currentValues,
  filterEnabled,
  getIcon,
  item,
  onToggleCheckbox
}) => {
  const icon = getIcon ? getIcon(item) : null;

  const handleChange = useCallback(() => {
    onToggleCheckbox(item.id);
  }, [item.id, onToggleCheckbox]);

  return (
    <div styleName="list-item list-item-half" key={item.id}>
      <div styleName="checkbox">
        <FilterCheckbox
          checked={includes(currentValues, item.id)}
          disabled={!filterEnabled || !enabled}
          onChange={handleChange}
          name={item.name}
        />
      </div>
      {icon && <div styleName="icon">{icon}</div>}
      <OverflowTooltip title={item.name} styleName="label">
        {item.name}
      </OverflowTooltip>
    </div>
  );
};

FilterGroupItem.propTypes = {
  currentValues: PropTypes.array,
  enabled: PropTypes.bool,
  filterEnabled: PropTypes.bool,
  getIcon: PropTypes.func,
  item: PropTypes.object,
  onToggleCheckbox: PropTypes.func
};

export default FilterGroupItem;
